module.exports = __webpack_public_path__ + "0ef0554716f7de0b8050c7624bb056c4.svg";


//////////////////
// WEBPACK FOOTER
// ./components/home/sample/credit-score-graph_mob.svg
// module id = 585
// module chunks = 0